import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import Header from '../components/common/Header';
import Footer from '../components/common/Footer';
import '../styles/legal.css';

const TermsAndConditions = () => {
  useEffect(() => {
    if (window.lucide) {
      window.lucide.createIcons();
    }
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="legal-page">
      <Header />
      
      <section className="legal-hero">
        <div className="container">
          <h1 className="legal-title">Terms & Conditions</h1>
          <p className="legal-subtitle">Please read these terms carefully before participating</p>
          <p className="legal-date">Last Updated: January 2025</p>
        </div>
      </section>

      <section className="legal-content">
        <div className="container">
          <div className="legal-card">
            <div className="legal-icon">
              <i data-lucide="alert-circle"></i>
            </div>
            <h2>Important Notice</h2>
            <p>
              By registering for a VIP Token with Offer Lifetime#, you acknowledge that you have read, understood, 
              and agree to be bound by these Terms and Conditions. If you do not agree with any part of these terms, 
              please do not register or participate in our program.
            </p>
          </div>

          <div className="legal-section">
            <h2><i data-lucide="users"></i> 1. Eligibility Requirements</h2>
            <ul>
              <li>Participants must be of legal age (18 years or older) in their jurisdiction.</li>
              <li>Only valid VIP Token Numbers obtained through official registration are eligible for prize draws.</li>
              <li>Employees, affiliates, and immediate family members of Offer Lifetime# are not eligible to participate.</li>
              <li>Participants must be residents of eligible countries as specified on our website.</li>
              <li>All information provided during registration must be accurate and truthful.</li>
            </ul>
          </div>

          <div className="legal-section">
            <h2><i data-lucide="file-check"></i> 2. Participation Rules</h2>
            <ul>
              <li>Completing the official registration form with accurate information is mandatory.</li>
              <li><strong>One VIP Token Number per individual.</strong> Multiple registrations using different identities will result in immediate disqualification.</li>
              <li><strong>Social Media Policy:</strong> Each social media account (Facebook, Instagram, YouTube, X/Twitter, LinkedIn) can only be used ONCE for registration. You cannot use the same social media ID for multiple accounts.</li>
              <li><strong>Mandatory Social Media Following:</strong> Following our official social media channels is mandatory for eligibility. You must follow us on all our platforms to remain eligible for prize draws.</li>
              <li>Participants must maintain active subscriptions to our social media channels throughout their participation.</li>
              <li>Participants must comply with all terms and conditions to remain eligible for prizes.</li>
              <li>Any attempt to manipulate the system or engage in fraudulent activity will result in permanent disqualification.</li>
            </ul>
          </div>

          <div className="legal-section">
            <h2><i data-lucide="trophy"></i> 3. Prize Distribution</h2>
            <ul>
              <li>Winners are selected randomly using a transparent and auditable selection process.</li>
              <li>Prize amounts are final and non-negotiable as specified in the current prize structure.</li>
              <li>Winners will be notified via registered email and phone number within 7 business days of selection.</li>
              <li>Prizes must be claimed within 30 days of notification, or they will be forfeited.</li>
              <li>All applicable taxes and fees are the responsibility of the winner.</li>
              <li>Prize money will be transferred directly to the winner's verified UPI account.</li>
              <li>Winners may be required to provide additional verification documents before prize distribution.</li>
            </ul>
          </div>

          <div className="legal-section">
            <h2><i data-lucide="share-2"></i> 4. Social Media Requirements</h2>
            <ul>
              <li><strong>One Account Per Platform:</strong> Each social media account can only be linked to ONE VIP Token registration. Using the same social media ID for multiple registrations is strictly prohibited.</li>
              <li><strong>Mandatory Following:</strong> You must follow all our official social media channels:
                <ul>
                  <li>Facebook: <a href="https://www.facebook.com/share/BGN8Hsn5brW3ymSZ/" target="_blank" rel="noopener noreferrer">Offer Lifetime Facebook</a></li>
                  <li>Instagram: <a href="https://www.instagram.com/invites/contact/?igsh=ujoji6x0nujz&utm_content=wafs0kc" target="_blank" rel="noopener noreferrer">Offer Lifetime Instagram</a></li>
                  <li>YouTube: <a href="https://www.youtube.com/@OfferLifeTime" target="_blank" rel="noopener noreferrer">Offer Lifetime YouTube</a></li>
                  <li>X (Twitter): <a href="https://x.com/offerlifetime?t=TTgHyI3oS3VQdffTGYTXPA&s=08" target="_blank" rel="noopener noreferrer">Offer Lifetime X</a></li>
                  <li>LinkedIn: <a href="https://www.linkedin.com/in/offer-lifetime-tm-b2806933a" target="_blank" rel="noopener noreferrer">Offer Lifetime LinkedIn</a></li>
                </ul>
              </li>
              <li>We reserve the right to verify your social media follows at any time.</li>
              <li>Unfollowing our channels may result in disqualification from current and future prize draws.</li>
            </ul>
          </div>

          <div className="legal-section">
            <h2><i data-lucide="shield"></i> 5. Account Security & Privacy</h2>
            <ul>
              <li>You are responsible for maintaining the confidentiality of your account credentials.</li>
              <li>You must not share your account with others or allow unauthorized access.</li>
              <li>We collect and process personal information in accordance with our Privacy Policy.</li>
              <li>Your UPI details will be used solely for prize distribution purposes.</li>
              <li>We implement industry-standard security measures to protect your data.</li>
            </ul>
          </div>

          <div className="legal-section">
            <h2><i data-lucide="alert-triangle"></i> 6. Prohibited Activities</h2>
            <ul>
              <li>Creating multiple accounts or registrations.</li>
              <li>Using the same social media accounts for multiple VIP Token registrations.</li>
              <li>Providing false or misleading information during registration.</li>
              <li>Attempting to manipulate or interfere with the prize selection process.</li>
              <li>Engaging in any fraudulent or deceptive practices.</li>
              <li>Violating any applicable laws or regulations.</li>
              <li>Harassing or abusing our staff or other participants.</li>
            </ul>
          </div>

          <div className="legal-section">
            <h2><i data-lucide="file-text"></i> 7. General Rules</h2>
            <ul>
              <li>Offer Lifetime# reserves the right to modify, suspend, or terminate the program at any time with or without notice.</li>
              <li>All decisions made by Offer Lifetime# regarding winner selection and prize distribution are final and binding.</li>
              <li>Fraudulent activity, misrepresentation, or violation of terms will result in immediate disqualification and potential legal action.</li>
              <li>Participants agree to allow Offer Lifetime# to use their testimonials and feedback (with consent) for promotional purposes.</li>
              <li>By participating, you agree to receive communications from Offer Lifetime# regarding the program.</li>
              <li>Offer Lifetime# is not responsible for technical issues that may affect participation or notification.</li>
              <li>These terms are governed by the laws of India and subject to the jurisdiction of courts in Kaithal, Haryana.</li>
            </ul>
          </div>

          <div className="legal-section">
            <h2><i data-lucide="refresh-cw"></i> 8. Modifications to Terms</h2>
            <p>
              We reserve the right to update or modify these Terms and Conditions at any time. Changes will be effective 
              immediately upon posting on our website. Your continued participation after such changes constitutes acceptance 
              of the modified terms. We encourage you to review these terms periodically.
            </p>
          </div>

          <div className="legal-section">
            <h2><i data-lucide="mail"></i> 9. Contact Information</h2>
            <p>
              If you have any questions about these Terms and Conditions, please contact us:
            </p>
            <ul>
              <li>Email: support@offerlifetime.com</li>
              <li>Phone: +91 8818001860</li>
              <li>WhatsApp: +91 8818001860</li>
              <li>Address: VPO BATTA TH. KALAYAT, DISST. KAITHAL, HARYANA, INDIA-136117</li>
            </ul>
          </div>

          <div className="legal-card legal-acceptance">
            <div className="legal-icon">
              <i data-lucide="check-circle"></i>
            </div>
            <h2>Acceptance of Terms</h2>
            <p>
              By clicking "I Agree" during registration or by using our services, you acknowledge that you have read 
              and understood these Terms and Conditions and agree to be bound by them. If you do not agree, please 
              do not register or use our services.
            </p>
          </div>

          <div className="legal-actions">
            <Link to="/" className="btn btn-secondary">Back to Home</Link>
            <Link to="/register" className="btn btn-primary">Register Now</Link>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default TermsAndConditions;
